import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
import FuPaApiError from 'app/models/error/FuPaApiError';
import TransferModuleHeader from 'app/components/transferModule/header/TransferModuleHeader';
import { useParams } from 'react-router';
import ResponsiveTransferList from 'app/components/transferModule/content/ResponsiveTransferList';
import LoadingSkeleton from 'app/components/transferModule/content/LoadingSkeleton';
import TransferModuleError from 'app/components/transferModule/TransferModuleError';
import { useQuery } from '@tanstack/react-query';
import { fetchRecentTransfers } from 'app/queries/districtTransfers';
const Wrapper = styled.div.withConfig({
  componentId: "sc-15fjc1y-0"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";"], COLORS.white);
export default function TransferModule(_ref) {
  let {
    initialData
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const {
    data,
    isError,
    refetch,
    isLoading
  } = useQuery({
    queryKey: ['recent-district-transfers', {
      districtSlug
    }],
    queryFn: () => fetchRecentTransfers(districtSlug),
    initialData: initialData,
    onError: error => error // only used for typing purposes
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TransferModuleHeader, {
      districtSlug: districtSlug
    }), /*#__PURE__*/React.createElement(LoadingSkeleton, null));
  }
  if (isError || !data) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TransferModuleHeader, null), /*#__PURE__*/React.createElement(TransferModuleError, {
      onRetry: refetch
    }));
  }
  if (data instanceof FuPaApiError) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      id: data.getHttpStatusId()
    }, /*#__PURE__*/React.createElement(TransferModuleHeader, null), /*#__PURE__*/React.createElement(TransferModuleError, {
      onRetry: refetch
    }));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TransferModule",
    "data-sentry-source-file": "TransferModule.tsx"
  }, /*#__PURE__*/React.createElement(TransferModuleHeader, {
    districtSlug: districtSlug,
    "data-sentry-element": "TransferModuleHeader",
    "data-sentry-source-file": "TransferModule.tsx"
  }), /*#__PURE__*/React.createElement(ResponsiveTransferList, {
    transfers: data,
    "data-sentry-element": "ResponsiveTransferList",
    "data-sentry-source-file": "TransferModule.tsx"
  }));
}